import { baseAPI } from '../../service/axios';

const fetchUsers = async params => baseAPI.get('user/list', { params });

export default fetchUsers;
